<script>
	import { Router, Route } from "svelte-routing";
	import MainMaintenanceRepair from "./Manage/MainMaintenanceRepair.svelte";
	import MainWorkshopWorkOrders from "./Manage/MainWorkshopWorkOrders.svelte";
	import MaintenanceRepairTabs from "./Tabs/MaintenanceRepairTabs.svelte";
	import VehicleTabRedirect from "./Tabs/VehicleTabRedirect.svelte";
	import { tabValueFromSlug } from "./Tabs/tabRoutes";
	import NotFound from "../NotFound.svelte";
	import { usesWorkshopView } from "src/config/permissions";
	import { userRole } from "src/store/store";
	import { isMnrPhase2Enabled } from "src/config/flag-config";
	import RedirectToLanding from "./RedirectToLanding.svelte";

	$: isWshop = usesWorkshopView($userRole);
</script>

<!-- Workshop users get an allowlist: any route not listed here falls through to NotFound. -->
<Router url="/">
	{#if isWshop && !isMnrPhase2Enabled}
		<Route component={NotFound} />
	{:else if isWshop}
		<Route path="/" component={MainWorkshopWorkOrders} />
		<Route path="/:vehicleId/details/:workOrderId" let:params>
			<MaintenanceRepairTabs
				vehicleId={params.vehicleId}
				workOrderId={params.workOrderId}
			/>
		</Route>
		<Route component={NotFound} />
	{:else}
		<Route path="/" component={MainMaintenanceRepair} />
		<Route path="/:vehicleId/details/:workOrderId" let:params>
			{#if isMnrPhase2Enabled}
				<MaintenanceRepairTabs
					vehicleId={params.vehicleId}
					workOrderId={params.workOrderId}
				/>
			{:else}
				<RedirectToLanding />
			{/if}
		</Route>
		<Route path="/:vehicleId/issues/create-issue" let:params>
			<MaintenanceRepairTabs
				vehicleId={params.vehicleId}
				tab="issues"
				isCreatingIssue
			/>
		</Route>
		<Route path="/:vehicleId/issues/:issueId/edit" let:params>
			{#key params.issueId}
				<MaintenanceRepairTabs
					vehicleId={params.vehicleId}
					tab="issues"
					editingIssueId={params.issueId}
				/>
			{/key}
		</Route>
		<Route path="/:vehicleId/:tab" let:params>
			{#if tabValueFromSlug(params.tab) && !isMnrPhase2Enabled && params.tab !== "issues"}
				<RedirectToLanding />
			{:else if tabValueFromSlug(params.tab)}
				<MaintenanceRepairTabs
					vehicleId={params.vehicleId}
					tab={params.tab}
				/>
			{:else}
				<NotFound />
			{/if}
		</Route>
		<Route path="/:vehicleId" let:params>
			<VehicleTabRedirect vehicleId={params.vehicleId} />
		</Route>
	{/if}
</Router>
